import { Grid2, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { useTranslate } from "../../../hooks/useTranslate";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { useStudents } from "../../../context/students";
import TaskCard from "../../../components/TaskCard";
import Article from "../../../components/Article";
import Students1 from "../../../assets/images/images/students1.jpg";
import Students2 from "../../../assets/images/images/community-students-2.jpg";
import { useGetNotices } from "../../../hooks/useGetNotices";
import EmptyContent from "../../../components/EmptyContent";
import useStatuses from "../../../context/status/useStatuses";
import { ISAMS_LINK } from "../../../services/isamsConfig";

const DESCRIPTION_TEXT = `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in.

Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in.

Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation `;

const Community = () => {
    const { t } = useTranslate();
    const navigate = useNavigate();

    const { activeStudentId } = useStudents();
    const { studentIsamsId } = useStatuses();
    const { notices, isLoading } = useGetNotices();

    return (
        <div className="page-content">
            <div className="student-head-section" />
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }}>
                    <Breadcrumbs
                        breadcrumbs={[
                            { label: t("navigation.home"), href: `/home/${activeStudentId}` },
                            { label: t("community.title"), current: true },
                        ]}
                    />
                    <Typography variant="h1" className="text-white">
                        {t("community.title")}
                    </Typography>
                    <Typography variant="body1" className="mt-4 text-white" component="div">
                        {t("community.subtitle")}
                    </Typography>
                    <Typography variant="h1" component="h2" className="mt-8 text-white">
                        {t("common.quickLinks")}
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 5, lg: 4 }}>
                    <div className="images-head-section">
                        <div className="img-head-section">
                            <img alt="students-1" src={Students1} />
                        </div>
                        <div className="img-head-section">
                            <img alt="students-2" src={Students2} />
                        </div>
                    </div>
                </Grid2>
            </Grid2>
            <Grid2 container spacing={4} className="mt-4">
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("community.extraCurriculurActivities")}>
                        <Typography variant="body1" component="div">
                            {t("community.extraCurriculurActivitiesText")}
                        </Typography>
                        <Button
                            href={`https://finance.kingsinterhigh.co.uk/clubs/?kihid=${studentIsamsId}`}
                            target="_blank"
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                    <TaskCard title={t("community.bookCommunicationPeriod")}>
                        <Typography variant="body1" component="div">
                            {t("community.bookCommunicationPeriodText")}
                        </Typography>
                        <Button
                            href="https://outlook.office.com/book/Test9@interhigh.co.uk"
                            target="_blank"
                            className="w-full mt-4 text-base button-primary"
                        >
                            {t("button.viewNow")}
                        </Button>
                    </TaskCard>
                </Grid2>
            </Grid2>
            {/* <div className="mt-12">
                <Typography variant="h2" className="text-primary">
                    {t("community.noticeBoard")}
                </Typography>
                <div className="mt-4">
                    <EmptyContent data={notices} text={t("common.noDataText")}>
                        <Article
                            title="News board article"
                            description={DESCRIPTION_TEXT}
                            className="mt-8"
                        />
                        <Article
                            title="News board article"
                            description={DESCRIPTION_TEXT}
                            className="mt-8"
                        />
                    </EmptyContent>
                </div>
            </div> */}
        </div>
    );
};

export default Community;
